import React, { useState } from 'react';
import './JoinForm.css';
import { functions } from '../firebase';
import { httpsCallable } from 'firebase/functions';

const JoinForm = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ success: false, error: null });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const waitForCustomerIO = () => {
    return new Promise((resolve, reject) => {
      let attempts = 0;
      const maxAttempts = 10;
      
      const checkForCIO = () => {
        if (window._cio && typeof window._cio.identify === 'function') {
          resolve(window._cio);
        } else if (attempts >= maxAttempts) {
          reject(new Error('Customer.io failed to load'));
        } else {
          attempts++;
          setTimeout(checkForCIO, 500);
        }
      };
      
      checkForCIO();
    });
  };

  const trackInCustomerIO = async () => {
    try {
      const _cio = await waitForCustomerIO();
      
      _cio.identify({
        id: formData.email,
        email: formData.email,
        first_name: formData.firstName,
        last_name: formData.lastName,
        created_at: Math.floor(Date.now() / 1000)
      });

      _cio.track('waitlist_joined', {
        email: formData.email,
        first_name: formData.firstName,
        last_name: formData.lastName
      });

      console.log('Successfully tracked in Customer.io');
    } catch (error) {
      console.error('Error tracking in Customer.io:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({ success: false, error: null });

    try {
      // Track in Customer.io first
      await trackInCustomerIO();

      // Submit to Firebase function
      const submitToWaitlist = httpsCallable(functions, 'submitWaitlistForm');
      const result = await submitToWaitlist({
        email: formData.email,
        firstName: formData.firstName,
        lastName: formData.lastName
      });

      if (result.data.success) {
        setSubmitStatus({ success: true, error: null });
        setFormData({ firstName: '', lastName: '', email: '' });
      } else {
        throw new Error(result.data.message || 'Error submitting form');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitStatus({ 
        success: false, 
        error: error.message || 'Error submitting form' 
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="join-form-container" id="join-form">
      {!submitStatus.success ? (
        <>
          <h2>Join the Waitlist</h2>
          <p>Be the first to know when we launch and get exclusive early access.</p>
          
          <form onSubmit={handleSubmit} className="join-form">
            <div className="form-group">
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleInputChange}
                placeholder="First Name"
                required
              />
            </div>
            
            <div className="form-group">
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleInputChange}
                placeholder="Last Name"
                required
              />
            </div>
            
            <div className="form-group">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Email Address"
                required
              />
            </div>

            <button 
              type="submit" 
              className="submit-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Joining...' : 'Join Waitlist'}
            </button>
          </form>
          
          {submitStatus.error && (
            <div className="error-message">
              {submitStatus.error}
            </div>
          )}
        </>
      ) : (
        <div className="success-message">
          <h2>Thanks! We'll keep you in the loop</h2>
          <p>We're excited to have you join our community. Stay tuned for updates!</p>
        </div>
      )}
    </div>
  );
};

export default JoinForm; 